import { useState } from "react";
import { Navbar } from "./components/Navbar";
import { HighscoresBox } from "./components/HighscoresBox";
import { GameBox } from "./GameBox";
import { StarsBg } from "./components/StarsBg";
import { Toaster } from "./components/Toaster";
import { useKonami } from "./components/useKonami";

type View = "game" | "highscores" | "about";

export function App() {
    const [view, setView] = useState<View>("game");
    useKonami();

    return (
        <>
            <StarsBg count={180} />
            <Toaster />
            <Navbar view={view} setView={setView} />
            {view === "game" && <GameBox />}
            {view === "highscores" && (
                <div className="highscores-center">
                    <HighscoresBox />
                </div>
            )}
            {view === "about" && (
                <div className="about-game">
                    <h2>🚀 Spacesheep — O grze</h2>
                    <div className="about-section">
                        <b>Spacesheep</b> to lekka gra logiczna w kosmicznym klimacie, w której wysyłasz owce na nowe planety!
                    </div>
                    <div className="about-section">
                        <strong>Na czym polega zabawa?</strong>
                        <ul>
                            <li>Załaduj dokładną liczbę owiec do statków według liczb Fibonacciego.</li>
                            <li>Nie możesz wybrać dwóch sąsiadujących statków ani partii owiec.</li>
                            <li>Pomnóż wybrane liczby, aby trafić idealnie w <b>cel misji</b>.</li>
                        </ul>
                    </div>
                    <div className="about-section">
                        <b>Każdy poziom</b> to coraz trudniejsze łamigłówki. Odblokowuj kolejne i rywalizuj na liście wyników!
                    </div>
                    <div className="about-section">
                        <strong>🎁 Easter egg:</strong> spróbuj sekwencji <code>↑ ↑ ↓ ↓ ← → ← → B A</code> 😉
                    </div>
                    <div className="about-section" style={{ fontStyle: "italic", opacity: 0.85 }}>
                        Powodzenia, Kapitanie! 🐑🛸
                    </div>
                </div>
            )}
        </>
    );
}
